<template>
    <div class="footer">
        <div class="col-12">Copyright © <a href="http://marqless.xyz">Alex Markules</a> {{ new Date().getFullYear() }}</div>
    </div>
</template>

<script setup>
</script>
<style scoped>
.footer {
    background-color: #000;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-top: 40px;
    display: inline-block;
    width: 100%;
}

</style>